// extracted by mini-css-extract-plugin
export var addButton = "_fg-0";
export var border = "_fg-8";
export var check = "_fg-h";
export var danger = "_fg-6";
export var dropdownContainer = "_fg-1";
export var editModalBody = "_fg-j";
export var footerContainer = "_fg-i";
export var fullWidth = "_fg-a";
export var hide = "_fg-9";
export var icon = "_fg-3";
export var input = "_fg-7";
export var inputFlex = "_fg-b";
export var inputWrapper = "_fg-c";
export var manualFocus = "_fg-5";
export var optionButton = "_fg-4";
export var pillWrapper = "_fg-e";
export var pointer = "_fg-2";
export var showOverflow = "_fg-f";
export var tagsFlex = "_fg-d";
export var xButton = "_fg-g";